import { StyleSheet } from 'aphrodite'
import { media } from 'consts'

const styles = StyleSheet.create({
  component: {
    marginLeft: media.file.dimensions.margin.left,
    marginBottom: media.file.dimensions.margin.left,
    marginTop: media.file.dimensions.margin.top,
    marginRight: media.file.dimensions.margin.right,
    width: media.file.dimensions.width,
    maxWidth: media.file.dimensions.width,
    minWidth: media.file.dimensions.width,
    height: media.file.dimensions.height,
    position: 'relative',
    display: 'block',
    outline: '1px solid #dadcde',
    background: '#fff',
    cursor: 'pointer',
    userSelect: 'none',
    ':hover': {
      outline: '1px solid #868686'
    }
  },
  selected: {
    outline: '2px solid #0069b4',
    ':hover': {
      outline: '2px solid #0069b4'
    }
  },
  removed: {
    outline: '2px solid #d9534f',
    ':hover': {
      outline: '2px solid #d9534f'
    },
    cursor: 'default'
  },
  image: {
    textAlign: 'center',
    verticalAlign: 'middle'
  },
  label: {
    fontSize: '13px',
    textOverflow: 'ellipsis',
    paddingLeft: 2,
    paddingRight: 2,
    paddingTop: 10,
    overflow: 'hidden',
    display: 'block',
    position: 'relative',
    whiteSpace: 'nowrap',
    color: '#545a5f',
    fontWeight: 400,
    WebkitFontSmoothing: 'antialiased'
  },
  labelWrapper: {
    display: 'block',
    textAlign: 'center',
    position: 'relative',
    height: 35,
    width: '100%'
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/Media/File/styles.js